import { GzInProductTrialsVideoWebComponent } from './component/GzInProductTrialsVideoWebComponent';
import { WEB_COMPONENT_IN_PRODUCT_TRIALS_VIDEO } from '../../../webcomponents.constants';

export { GzInProductTrialsVideoWebComponent };

window.customElements.define(WEB_COMPONENT_IN_PRODUCT_TRIALS_VIDEO, GzInProductTrialsVideoWebComponent);
